<template>
  <dialog-reset
    title="PLC数据模拟"
    width="600px"
    height="40vh"
    top="10vh"
    :visible.sync="visible"
  >
    <avue-form
      ref="form"
      v-model="form"
      :option="option"
    />

    <div slot="dialog_footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">
        提交
      </el-button>
    </div>

    <!-- 设备选择弹窗 -->
    <select-device-list
      ref="selectDeviceList"
      @replace="handleDeviceSelect"
    />
  </dialog-reset>
</template>

<script>
import SelectDeviceList from "./select-device-list.vue";
import { simulatePlcData } from "../api";

export default {
  name: "PlcSimulatorDialog",
  components: {
    SelectDeviceList,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        deviceId: "",
        deviceName: "",
        parameterKey: "",
        parameterValue: "",
      },
      option: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 120,
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            placeholder: "请选择设备",
            readonly: true,
            span:24,
            rules: [
              {
                required: true,
                message: "请选择设备",
                trigger: "change",
              },
            ],
            click: () => {
              this.openDeviceSelector();
            },
          },
          {
            label: "参数Key",
            prop: "parameterKey",
            placeholder: "请输入参数Key",
            span:24,
            rules: [
              {
                required: true,
                message: "请输入参数Key",
                trigger: "blur",
              },
            ],
          },
          {
            label: "参数值",
            prop: "parameterValue",
            placeholder: "请输入参数值",
            span:24,
            rules: [
              {
                required: true,
                message: "请输入参数值",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    // 打开设备选择器
    openDeviceSelector() {
      if (this.$refs.selectDeviceList) {
        this.$refs.selectDeviceList.open();
      }
    },

    // 处理设备选择
    handleDeviceSelect(device) {
      this.form.deviceId = device.id;
      this.form.deviceName = device.deviceName;
    },

    // 重置表单
    resetForm() {
      this.form = {
        deviceId: "",
        deviceName: "",
        parameterKey: "",
        parameterValue: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetForm();
      }
    },

    // 取消
    handleCancel() {
      this.$emit("update:visible", false);
    },

    // 提交
    async handleSubmit() {
      try {

        this.$refs.form.validate((valid, done) => {
          if (valid) {
            console.log(valid)
          }
        })

        if (!this.form.deviceId) {
          this.$message.warning("请选择设备");
          return;
        }

        this.loading = true;

        const params = {
          deviceId: this.form.deviceId,
          parameterKey: this.form.parameterKey,
          parameterValue: this.form.parameterValue,
        };

        const response = await simulatePlcData(params);
        // console.log(response)
        if (response && response.data.code === 200 ) {
          this.$message.success("PLC数据模拟成功");
          this.$emit("update:visible", false);
          this.$emit("refresh");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>

